import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface UseRedirectHiddenTabProps {
  currentKey: string
  hiddenKeys: Array<string | false | null | undefined>
  isLoading: boolean
  fallbackPath: string
}

export const useRedirectHiddenTab = ({ currentKey, hiddenKeys, isLoading, fallbackPath }: UseRedirectHiddenTabProps) => {
  const navigate = useNavigate()
  const isHidden = hiddenKeys.includes(currentKey)

  useEffect(() => {
    if (isLoading) {
      return
    }
    if (isHidden) {
      navigate(fallbackPath, { replace: true })
    }
  }, [isLoading, isHidden, fallbackPath, navigate])
}
